import React from "react";
import { CloudPlatformCardProps } from "../cloud-platform/types";
import { useStyles } from "./styles";

export const CloudPlatformCard = (props: CloudPlatformCardProps) => {
    const classes = useStyles();

    return (
        <div className={[classes.cardItemContainer, ...(props.classes || [])].join(' ')}>
            <div className={"cardTexHelper " + classes.cardTextContainer} data-position={props.position}>
                <div>
                    {props.subtitle && <div className={"h4 " + classes.cardSubtitle}>{props.subtitle}</div>}
                    {props.title && <div className={"h2 " + classes.cardTitle}>{props.title}</div>}
                    {props.body && <div className={"h4 " + classes.cardBody}>{props.body}</div>}
                </div>
            </div>
            <div className={"cardImgHelper " + classes.cardImgContainer} data-position={props.position}>
                {props.img}
                {props.video}
            </div>
        </div>
    );
};
